import msg from './messages.js'

const infoHeaderLabel = (color, label, title, body, setText, openDialog) => {
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'nowrap', margin: '1em', height: '100%', width: '100%'}}>
            <img src={"/icons/info" + color + ".svg"}
                style={{height: '1.5em', width: '1.5em'}}
                onClick={(e) => {
                    e.stopPropagation();
                    setText({title: title, body: body}); 
                    openDialog();
                }}/> 
                    {label}
        </div>)
}

const constants = {
    
    id: '$id',
    values: '$values',
    divisions: 'divisions',
    division: 'division',
    divisionId: 'divisionId',
    divisionName: 'divisionName',
    latitude: 'latitude',
    longitude: 'longitude',
    regionId: 'regionId',
    region: 'region',
    location: 'location',
    locationId: 'locationId',
    locationName: 'locationName',
    seasonNumber: 'seasonNumber',
    seasonYear: 'seasonYear',
    standings: 'Player Statistics',
    teamStandings: 'Team Standings',
    moreStandings: 'More Standings',
    moreStatistics: 'More Statistics',
    multipleTeams: 'Multiple Teams',
    registration: 'registration',


    playerId: 'playerId',
    firstName: 'firstName',
    middleName: 'middleName',
    lastName: 'lastName',
    fullName: 'fullName',
    dupr: 'dupr',
    ranking: 'ranking',

    club: 'club',
    clubId: 'clubId',
    clubName: 'clubName',
    clubLogo: 'clubLogo',
    logo: 'logo',
    color: 'color',
    name: 'name',

    teamId: 'teamId',
    teamName: 'teamName',
    fullTeam: 'fullTeam',
    pod: 'pod',
    podValue: 'podValue',
    weekNumber: 'weekNumber',
    wins: 'wins',
    losses: 'losses',
    draws: 'draws',
    overallRecord: 'overallRecord',

    matchup: 'matchup',
    matchupId: 'matchupId',
    matchupDate: 'matchupDate',
    matchType: 'matchType',
    gameNumber: 'gameNumber',
    matchupPlayerStats: 'matchupPlayerStats',
    teamStatistics: 'teamStatistics',
    scheduledTime: 'scheduledTime',
    lineups: 'lineups',
    totalWins: 'totalWins',
    endResult: 'endResult',

    home: 'home',
    homeTeam: 'homeTeam',
    homeClub: 'homeClub',
    homeTeamId: 'homeTeamId',
    homeName: 'homeName',
    homeMales: 'homeMales',
    homeFemales: 'homeFemales',
    homePlayers: 'homePlayers',
    homePlayer1: 'homePlayerId1',
    homePlayer2: 'homePlayerId2',
    homeWins: 'homeWins',
    homePodRanking: 'homePodRanking',

    away: 'away',
    awayTeam: 'awayTeam',
    awayClub: 'awayClub',
    awayTeamId: 'awayTeamId',
    awayName: 'awayName',
    awayMales: 'awayMales',
    awayFemales: 'awayFemales',
    awayPlayers: 'awayPlayers',
    awayPlayer1: 'awayPlayerId1',
    awayPlayer2: 'awayPlayerId2',
    awayWins: 'awayWins',
    awayPodRanking: 'awayPodRanking',

    both: 'both',
    gender: 'gender',

    male: 'male',
    female: 'female',
    Male: 'Male',
    Female: 'Female',
    homePoints: 'homePoints',
    homeScore: 'homeScore',
    awayPoints: 'awayPoints',
    awayScore: 'awayScore',
    pointsPerGame: 'pointsPerGame',
    scheduledTimeUtc: 'scheduledTimeUtc',

    mixed: 'mixed',
    men: 'Men',
    women: 'Women',
    mens: 'Mens',
    womens: 'Womens',
    playoffs: 'playoffs',

    maxGeneralLineupSelection: 6,
    maxGenderLineupSelection: 12,
    maxGamesPlayed: 3,

    loginCode: 'loginCode',

    all: 'All',
    
    record: 'Record',
    place: 'Place',
    podPlace: 'Pod Place',
    teamPlayerStats: 'playerStats',
    statistics: 'statistics',
    schedule: 'schedule',
    date: 'date',
    time: 'time',
    opponent: 'opponent',
    podRanking: 'podRanking',
    scorecard: 'scorecard',

    cplEmail: '',
    
    general: 'general',
    club: 'club',

    byeTeamId: '00000000-0000-0000-0000-000000000000',

    playoffRounds: ['Round of 16', 'Quarterfinals', 'Semifinals', 'Championship'],

    playoffRoundsShort: ['RO16', 'Quarters', 'Semis', 'Finals'],

    // Spring is 1, etc. This should never be 0
    seasonLabel: ['0', 'Spring', 'Summer', 'Fall', 'Winter'],

    saved: 'saved',
    late: 'late',
    notSubmitted: 'notSubmitted',

    // This isn't an API response field, but we use this to track how many penalty games there are
    penaltyGamesCount: 'penaltyGamesCount',

    api: {
        record : 'record',
        ranking: 'ranking',
        club: 'club',
        color: 'color',
        location: 'location',
        facebook: 'facebook',
        instagram: 'instagram',
        youtube: 'youtube',
        website: 'website',
        address: 'address',
        phone: 'phone',
        seasonId: 'seasonId',
        seasonNumber: 'seasonNumber',
        seasonYear: 'seasonYear',
        inConferenceRecord: 'inConferenceRecord',
        inConferenceWinRate: 'inConferenceWinRate',
        positions: 'positions',
        playerPositions: 'playerPositions',
        podRanking: 'podRanking',
        totalPointsWon: 'totalPointsWon',
        averagePointsPerGame: 'averagePointsPerGame',
        averagePointDifferential: 'averagePointDifferential',
        gameRecord: 'gameRecord',
        homeRecord: 'homeRecord',
        homeWinRate: 'homeWinRate',
        homeGameWins: 'homeGameWins',
        homeGameLosses: 'homeGameLosses',
        awayRecord: 'awayRecord',
        awayWinRate: 'awayWinRate',
        awayGameWins: 'awayGameWins',
        awayGameLosses: 'awayGameLosses',
        womensRecord: 'womensRecord',
        womenWinRate: 'womenWinRate',
        mixedRecord: 'mixedRecord',
        mixedWinRate: 'mixedWinRate',
        mensRecord: 'mensRecord',
        menWinRate: 'menWinRate',
        penalties: 'penalties',
        finalScore: 'finalScore',
        gamePunishment: 'gamePunishment',
        awayLineupLocked: 'awayLineupLocked',
        homeLineupLocked: 'homeLineupLocked',
        lineupRestrictedAway: 'lineupRestrictedAway',
        lineupRestrictedHome: 'lineupRestrictedHome',
        penaltyTypeId: 'penaltyTypeId'
    },

    penalties: {
        late: 1,
    },

    header: {
        registration: 'Registration', 
        leagues: 'Leagues', 
        contactUs: 'Contact Us', 
        aboutUs: 'About Us',
        clubRegistration: 'Club Registration',
        teamRegistration: 'Team Registration',
        playerRegistration: 'Player Registration',
        localRegistration: 'Local League Registration',
        crossClubLeague: 'Mixed Leagues',
        localLeague: 'Local Leagues',
        ladderLeague: 'Ladder Leagues',
        genderLeague: 'Gender Leagues',
        cplMerch: 'CPL Merch',
        njpaMerch: 'NJ/PA Jerseys',
        ctmaMerch: 'CT/MA Jerseys',
        dcBaltimoreMerch: 'DC/Baltimore Jerseys',
        contactUs: 'Contact Us',
        incidentReport: 'CPL Incident Report',
        lineupSaved: 'Lineup Saved',
        lineupSavedLate: 'Lineup Saved Late',
        lineupNotCompleted: 'Lineup Not Completed',
    },

    table: {
        playerCols : (setDialogText, openInfoDialog) => [
            {label: infoHeaderLabel("-blue", "Rank", "Rank", msg.rankingInfoText, setDialogText, openInfoDialog), value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Gender', value: 'gender', text:'center'},
            {label: 'Matches Played', value: 'matchesPlayed', text:'center'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-blue", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed PPG', value: 'mixedPPG', text:'center'},
            {label: 'Mixed Wins', value: 'mixedWins', text:'center'},
            {label: 'Mixed Losses', value: 'mixedLosses', text:'center'},
            {label: 'Gender PPG', value: 'genderPPG', text:'center'},
            {label: 'Gender Wins', value: 'genderWins', text:'center'},
            {label: 'Gender Losses', value: 'genderLosses', text:'center'},
            {label: infoHeaderLabel("-blue", "Strength of Opponent", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), 
                shortLabel: infoHeaderLabel("-blue", "SOO", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), value: 'strengthOfOpponent', text:'center'},
            {label: 'Strength of Game', shortLabel:'SoG', value: 'strengthOfGame', text:'center'},
        ],

        genderedPlayerCols : (setDialogText, openInfoDialog) => [
            {label: infoHeaderLabel("-blue", "Rank", "Rank", msg.rankingInfoText, setDialogText, openInfoDialog), value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Matches Played', value: 'matchesPlayed', text:'center'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-blue", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed PPG', value: 'mixedPPG', text:'center'},
            {label: 'Mixed Wins', value: 'mixedWins', text:'center'},
            {label: 'Mixed Losses', value: 'mixedLosses', text:'center'},
            {label: 'Gender PPG', value: 'genderPPG', text:'center'},
            {label: 'Gender Wins', value: 'genderWins', text:'center'},
            {label: 'Gender Losses', value: 'genderLosses', text:'center'},
            {label: infoHeaderLabel("-blue", "Strength of Opponent", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), 
                shortLabel: infoHeaderLabel("-blue", "SOO", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), value: 'strengthOfOpponent', text:'center'},
            {label: 'Strength of Game', shortLabel:'SoG', value: 'strengthOfGame', text:'center'},
        ],

        careerCols : (setDialogText, openInfoDialog) => [
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Team(s)', value: 'teamName', text: 'start'},
            {label: 'Gender', value: 'gender', text:'center'},
            {label: 'Seasons Played', value: 'seasonsPlayed', text:'center'}, 
            {label: 'Matches Played', value: 'matchesPlayed', text:'center'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-blue", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed Wins', value: 'mixedWins', text:'center'},
            {label: 'Mixed Losses', value: 'mixedLosses', text:'center'},
            {label: 'Mixed Win %', value: 'mixedWinRate', text:'center'},
            {label: 'Gender PPG', value: 'genderPPG', text:'center'},
            {label: 'Gender Wins', value: 'genderWins', text:'center'},
            {label: 'Gender Losses', value: 'genderLosses', text:'center'},
            {label: 'Gender Win %', value: 'genderWinRate', text:'center'},
            
        ],

        genderedCareerCols : (setDialogText, openInfoDialog) => [
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Team(s)', value: 'teamName', text: 'start'},
            {label: 'Seasons Played', value: 'seasonsPlayed', text:'center'}, 
            {label: 'Matches Played', value: 'matchesPlayed', text:'center'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-blue", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed Wins', value: 'mixedWins', text:'center'},
            {label: 'Mixed Losses', value: 'mixedLosses', text:'center'},
            {label: 'Mixed Win %', value: 'mixedWinRate', text:'center'},
            {label: 'Gender PPG', value: 'genderPPG', text:'center'},
            {label: 'Gender Wins', value: 'genderWins', text:'center'},
            {label: 'Gender Losses', value: 'genderLosses', text:'center'},
            {label: 'Gender Win %', value: 'genderWinRate', text:'center'},
        ],

        genderLeaguePlayerCols : (setDialogText, openInfoDialog) => [
            {label: infoHeaderLabel("-blue", "Rank", "Rank", msg.rankingInfoText, setDialogText, openInfoDialog), value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Matches Played', value: 'matchesPlayed', text:'center'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-blue", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: infoHeaderLabel("-blue", "Strength of Opponent", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), 
                shortLabel: infoHeaderLabel("-blue", "SOO", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), value: 'strengthOfOpponent', text:'center'},
            {label: 'Strength of Game', shortLabel:'SoG', value: 'strengthOfGame', text:'center'},
        ],

        teamCols : [
            {label: 'Place', value: 'ranking', text:'center'},
            {label: 'Team', value: 'fullTeam', text:'start'}, 
            {label: 'Pod', value: 'pod', text:'center'}, 
            {label: 'Record', value: 'record', text:'center'}, 
            {label: 'Win %', value: 'winPercentage', text:'center'}, 
            {label: 'In-Conference Record', shortLabel: 'In-Con Record', value: 'conferenceRecord', text: 'center'},
            {label: 'In-Conference Win %', shortLabel: 'In-Con Win %', value: 'conferenceWinPercentage', text: 'center'},
            {label: 'Game Record', value: 'gameRecord', text:'center'},
            {label: 'Game Win %', value: 'gameWinRate', text:'center'},
            {label: 'Home Record', value: 'homeRecord', text:'center'}, 
            {label: 'Home Win %', value: 'homeWinRate', text:'center'}, 
            {label: 'Away Record', value: 'awayRecord', text:'center'}, 
            {label: 'Away Win %', value: 'awayWinRate', text:'center'}, 
            {label: 'Avg PPG', value: 'averagePointsPerGame', text:'center'},
            {label: 'Avg Point Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Team Point Diff', value: 'teamPointDiff', text:'center'},
            {label: 'Clutch Record', value: 'clutchRecord', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed Record', value: 'mixedRecord', text:'center'},
            {label: 'Mixed Win %', value: 'mixedWinRate', text:'center'},
            {label: 'Men\'s Record', value: 'mensRecord', text:'center'},
            {label: 'Men\'s Win %', value: 'menWinRate', text:'center'},
            {label: 'Women\'s Record', value: 'womensRecord', text:'center'},
            {label: 'Women\'s Win %', value: 'womenWinRate', text:'center'},
        ],

        teamPodCols : [
            {label: 'Place', value: 'podRanking', text:'center'},
            {label: 'Team', value: 'fullTeam', text:'start'},
            {label: 'Record', value: 'overallRecord', text:'center'}, 
            {label: 'Win %', value: 'winPercentage', text:'center'}, 
            {label: 'Game Record', value: 'gameRecord', text:'center'},
            {label: 'Game Win %', value: 'gameWinRate', text:'center'},
            {label: 'Home Record', value: 'homeRecord', text:'center'}, 
            {label: 'Home Win %', value: 'homeWinRate', text:'center'}, 
            {label: 'Away Record', value: 'awayRecord', text:'center'}, 
            {label: 'Away Win %', value: 'awayWinRate', text:'center'}, 
            {label: 'Avg PPG', value: 'averagePointsPerGame', text:'center'},
            {label: 'Avg Point Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Team Point Diff', value: 'teamPointDiff', text:'center'},
            {label: 'Clutch Record', value: 'clutchRecord', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed Record', value: 'mixedRecord', text:'center'},
            {label: 'Mixed Win %', value: 'mixedWinRate', text:'center'},
            {label: 'Men\'s Record', value: 'mensRecord', text:'center'},
            {label: 'Men\'s Win %', value: 'menWinRate', text:'center'},
            {label: 'Women\'s Record', value: 'womensRecord', text:'center'},
            {label: 'Women\'s Win %', value: 'womenWinRate', text:'center'},
        ],

        clubCols : [
            {label: 'Place', value: 'ranking', text:'center'},
            {label: 'Team', value: 'fullTeam', text:'start'}, 
            {label: 'Record', value: 'record', text:'center'}, 
            {label: 'Win %', value: 'winPercentage', text:'center'}, 
            {label: 'Game Record', value: 'gameRecord', text:'center'},
            {label: 'Game Win %', value: 'gameWinRate', text:'center'},
            {label: 'Home Record', value: 'homeRecord', text:'center'}, 
            {label: 'Home Win %', value: 'homeWinRate', text:'center'}, 
            {label: 'Away Record', value: 'awayRecord', text:'center'}, 
            {label: 'Away Win %', value: 'awayWinRate', text:'center'}, 
            {label: 'Avg PPG', value: 'averagePointsPerGame', text:'center'},
            {label: 'Avg Point Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Team Point Diff', value: 'teamPointDiff', text:'center'},
            {label: 'Clutch Record', value: 'clutchRecord', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed Record', value: 'mixedRecord', text:'center'},
            {label: 'Mixed Win %', value: 'mixedWinRate', text:'center'},
            {label: 'Men\'s Record', value: 'mensRecord', text:'center'},
            {label: 'Men\'s Win %', value: 'menWinRate', text:'center'},
            {label: 'Women\'s Record', value: 'womensRecord', text:'center'},
            {label: 'Women\'s Win %', value: 'womenWinRate', text:'center'},
        ],

        genderStandingsCols : [
            {label: 'Place', value: 'ranking', text:'center'},
            {label: 'Team', value: 'fullTeam', text:'start'}, 
            {label: 'Pod', value: 'pod', text:'center'}, 
            {label: 'Record', value: 'record', text:'center'}, 
            {label: 'Win %', value: 'winPercentage', text:'center'}, 
            {label: 'In-Conference Record', shortLabel: 'In-Con Record', value: 'conferenceRecord', text: 'center'},
            {label: 'In-Conference Win %', shortLabel: 'In-Con Win %', value: 'conferenceWinPercentage', text: 'center'},
            {label: 'Game Record', value: 'gameRecord', text:'center'},
            {label: 'Game Win %', value: 'gameWinRate', text:'center'},
            {label: 'Home Record', value: 'homeRecord', text:'center'}, 
            {label: 'Home Win %', value: 'homeWinRate', text:'center'}, 
            {label: 'Away Record', value: 'awayRecord', text:'center'}, 
            {label: 'Away Win %', value: 'awayWinRate', text:'center'}, 
            {label: 'Avg PPG', value: 'averagePointsPerGame', text:'center'},
            {label: 'Avg Point Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Team Point Diff', value: 'teamPointDiff', text:'center'},
            {label: 'Clutch Record', value: 'clutchRecord', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
        ],

        dashboardTeamCols : [
            {label: 'Rank', value: 'ranking', text:'center'},
            {label: 'Team', value: 'fullTeam', text:'start'},
            {label: 'Pod', value: 'pod', text:'center'},
            {label: 'Record', value: 'record', text:'start'},
        ], 

        dashboardPlayerCols : [
            {label: 'Rank', value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'},
            {label: 'Team', value: 'fullTeam', text:'start'},
            // {label: 'Previous Rank', value: 'previousRank', width:'15%'},
        ],

        rosterCols : [
            {label: 'Rank', value: 'ranking', text:'center', width: '10%'},
            {label: 'Name', value: 'name', text:'start', width: '60%'},
        ],

        localRosterCols : [
            {label: 'Rank', value: 'ranking', text:'center', width: '10%'},
            {label: 'Name', value: 'name', text:'start', width: '45%'},
            {label: 'Gender', value: 'gender', text:'center', width: '15%'},
        ],

        lineupTeamStatsCols : [
            {label: "Total Wins", value: 'totalWins'},
            {label: "Penalized Games", value: 'penaltyGamesCount'},
            {label: "Win %", value: 'winPercentage'}, 
            {label: "Mixed Wins", value: 'mixedWins'},
            {label: "Mixed Win %", value: 'mixedWinPercentage'},
            {label: "Men's Wins", value: 'mensWins'},
            {label: "Men's Win %", value: 'mensWinPercentage'},
            {label: "Women's Wins", value: 'womensWins'},
            {label: "Women's Win %", value: 'womensWinPercentage'},
            {label: "Total Points Won",  shortLabel:'Ttl Pts Won', value: 'totalPointsWon'},
            {label: "Average Points Per Game", shortLabel:'Avg PPG', value: 'averagePointsPerGame'},
            {label: "Total Point Differential", shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential'},
            {label: "Average Point Differential", shortLabel:'Avg Pt Diff', value: 'averagePointDifferential'},
            {label: 'Total Clutch Wins', value: 'clutchWins'}
        ],

        lineupGenderTeamStatsCols : [
            {label: "Total Wins", value: 'totalWins'},
            {label: "Penalized Games", value: 'penaltyGamesCount'},
            {label: "Win %", value: 'winPercentage'}, 
            {label: "Total Points Won",  shortLabel:'Ttl Pts Won', value: 'totalPointsWon'},
            {label: "Average Points Per Game", shortLabel:'Avg PPG', value: 'averagePointsPerGame'},
            {label: "Total Point Differential", shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential'},
            {label: "Average Point Differential", shortLabel:'Avg Pt Diff', value: 'averagePointDifferential'},
            {label: 'Total Clutch Wins', value: 'clutchWins'}
        ],

        playerResultCols : (setDialogText, openInfoDialog) => [
            {label: infoHeaderLabel("-white", "Rank", "Rank", msg.rankingInfoText, setDialogText, openInfoDialog), value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Gender', value: 'gender', text:'center'},
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-white", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: 'Mixed PPG', value: 'mixedPPG', text:'center'},
            {label: 'Mixed Wins', value: 'mixedWins', text:'center'},
            {label: 'Mixed Losses', value: 'mixedLosses', text:'center'},
            {label: 'Gender PPG', value: 'genderPPG', text:'center'},
            {label: 'Gender Wins', value: 'genderWins', text:'center'},
            {label: 'Gender Losses', value: 'genderLosses', text:'center'},
            {label: infoHeaderLabel("-white", "Strength of Opponent", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), 
                shortLabel: infoHeaderLabel("-white", "SOO", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), value: 'strengthOfOpponent', text:'center'},
        ],

        genderResultCols : (setDialogText, openInfoDialog) => [
            {label: infoHeaderLabel("-white", "Rank", "Rank", msg.rankingInfoText, setDialogText, openInfoDialog), value: 'ranking', text:'center'},
            {label: 'Name', value: 'fullName', text:'start'}, 
            {label: 'Games Played', value: 'gamesPlayed', text:'center'}, 
            {label: 'Wins', value: 'wins', text:'center'}, 
            {label: 'Losses', value: 'losses', text:'center'}, 
            {label: 'Win %', value: 'winRate', text:'center'}, 
            {label: 'Points Per Game', shortLabel:'PPG', value: 'pointsPerGame', text:'center'},
            {label: 'Points Won', value: 'pointsWon', text:'center'},
            {label: 'Average Point Differential', shortLabel:'Avg Pt Diff', value: 'averagePointDifferential', text:'center'},
            {label: 'Total Point Differential', shortLabel:'Ttl Pt Diff', value: 'totalPointDifferential', text:'center'},
            {label: infoHeaderLabel("-white", "Clutch Wins", "Clutch Wins", msg.clutchWinsInfoText, setDialogText, openInfoDialog), value: 'clutchWins', text:'center'},
            {label: 'Clutch Losses', value: 'clutchLosses', text:'center'},
            {label: 'Clutch Win %', value: 'clutchWinRate', text:'center'},
            {label: infoHeaderLabel("-white", "Strength of Opponent", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), 
                shortLabel: infoHeaderLabel("-white", "SOO", "Strength of Opponent", msg.strengthOfOpponentInfoText, setDialogText, openInfoDialog), value: 'strengthOfOpponent', text:'center'},
        ],

        teamStatsRecordCols : [
            {label: 'Home Record', value: 'homeRecord', },
            {label: 'Home Win %', value: 'homeWinRate', },
            {label: 'Away Record', value: 'awayRecord', },
            {label: 'Away Win %', value: 'awayWinRate', },
            {label: 'Game Record', value: 'gameRecord', },
            {label: 'Game Win', value: 'gameWinRate', },
        ],

        teamStatsPointsCols : [
            {label: 'Total Points Won', value: 'totalPointsWon', shortLabel:'Ttl Pts Won'},
            {label: 'Average PPG', value: 'averagePointsPerGame', shortLabel:'Avg PPG'},
            {label: 'Team Point Diff', value: 'teamPointDiff'},
            {label: 'Mixed Record', value: 'mixedRecord'},
            {label: 'Mixed Win %', value: 'mixedWinRate'},
            {label: 'Men\'s Record', value: 'mensRecord'},
            {label: 'Men\'s Win %', value: 'menWinRate'},
            {label: 'Women\'s Record', value: 'womensRecord'},
            {label: 'Women\'s Win %', value: 'womenWinRate'},
        ],

        teamScheduleCols : [
            {label: 'Week', value: 'weekNumber', text:'center'},
            {label: 'Date', value: 'date', text:'center'},
            {label: 'Location', value: 'location', text: 'center'},
            {label: 'Opponent', value: 'opponent', text:'center'},
            {label: 'Address', value: 'address', text:'center'},
            // {label: '', value: 'location'},
            {label: 'Time', value: 'time', text:'center'},
            {label: 'Wins', value: 'wins', text:'center'},
            {label: 'Losses', value: 'losses', text:'center'},
            {label: 'Match Scorecard', value: 'scorecard', text:'center'},
        ]
    },

    leagueType: {
        crossClubLeague: 'crossClubLeague',
        localLeague: 'localLeague',
        genderLeague: 'genderLeague',
    },

    titles: {
        dashboard: 'DASHBOARD',
        playerStats : 'PLAYER STATISTICS',
        teamStats : 'TEAM STANDINGS',
        lineups : 'LINEUPS',
        teams: 'TEAM STATS',
        playoffs: 'PLAYOFFS',
        clubRegistration: 'CLUB REGISTRATION',
        teamRegistration: 'TEAM REGISTRATION',
        playerRegistration: 'PLAYER REGISTRATION',
        localRegistration: 'LOCAL LEAGUE REGISTRATION',
        incidentReport: 'CPL INCIDENT & VIOLATION REPORTING FORM',
        homeVsAway: 'HOME VS AWAY',
        winRateByFormat: 'WIN % BY FORMAT',
    },

    labels: {
        regions: 'Region',
        club: 'Clubs',
        division: 'Division',
        seasons: 'Season Archive',
        undo: 'Undo',
        clear: 'Clear',
        save: 'Save',
        submit: 'Submit Scores',
        generateLineup: 'Generate Lineup',
        setLineup: 'Set Lineup',
        saveLineup: 'Save Lineup',
        standing: 'Standing',
        totalPointsWon: 'Total Points Won',
        averagePPG: 'Average PPG',
        pointDifferential: 'Point Differential',
        gameRecord: 'Game Record',
        winrate: 'win Rate',
        womens: 'Women\'s',
        mens: 'Men\'s',
        mixed: 'Mixed',
        record: 'Record',
        match: 'Match',
        game: 'Game',
        home: 'Home',
        away: 'Away',
        podRanking: 'Pod Ranking',
        leagueType: 'League Type',
        mixedLeagues: 'Mixed Leagues',
        genderLeagues: 'Gender Leagues',
        localLeagues: 'Local Leagues',
    },

    sidebarItems : ['dashboard', 'lineups', 'standings', 'players', 'playoffs', 'teams'],

    pages : {
        playerRegistration: 'player-registration',
        clubRegistration: 'club-registration',
        teamRegistration: 'team-registration',
        localRegistration: 'local-registration',
        leagues: 'leagues',
        localLeagues: 'local-leagues',
        genderLeagues: 'gender-leagues',
        aboutUs: 'about-us',
        contactUs: 'contact-us',
        incidentReport: 'incident-report',
    },

    uri : {
        local: `/local`,
        gender: `/gender`,
        base: `/v0/api`,
        seasons: `/seasons`,
        regions: `/regions`,
        clubs: `/clubs`,
        standings: (divisionId) => `/divisions/${divisionId}/standings`,
        players: (divisionId) => `/divisions/${divisionId}/players`,
        listMatchups: (date) => `/home/date/${date}`,
        matchups: (divisionId) => `/divisions/${divisionId}/matchups`,
        matchup: (matchupId) => `/matchup/${matchupId}/lineups`,
        matchupResults: (divisionId, matchupId) => `/divisions/${divisionId}/matchups/${matchupId}`,
        localPlayerPosition: (divisionId, matchupId) => `/divisions/${divisionId}/matchups/${matchupId}/playerPositions`,
        submitMatchup: (matchupId) => `/matchup/${matchupId}/lineups/submit`,
        matchupCode: (divisionId, matchupId) => `/divisions/${divisionId}/matchups/${matchupId}/code`,
        careerQuery: `?careerStats=true`,
        contactUs: `/v0/api/contact`,
        teams: (divisionId) => `/divisions/${divisionId}/teams`,

    },

    colors : {
        cplNavy: '#001A52',
        cplBlue: '#003AB8',
        cplYellow: '#FFE700',
        cplOrage: '	#F29D38',
        cplLightOrange: '#FEEBD0',
        cplGray: '#F8F9FA',
        cplDarkGray: '#E9E9EA',
        cplWhite: '#FFFFFF',
        cplRed: '#BB2124',
        cplGreen: '#22BB33',
        cplLightGreen: '#9DD4A5',
        cplDarkGreen: '#314C1C',
        cplBlack: '#333333',
        cplPink: '	#FEC5C3'
    },

    icons : {
        cplBlue: '-blue.svg',
        cplYellow: '-yellow.svg',
    },

    playerStats : {
        season: 'Season',
        career: 'Career',
        male: 'Male',
        female: 'Female',
        gender: 'gender',
    },

    genderSelect : [
        {label: 'All', value: 'All'},
        {label: 'Male', value: 'Male'},
        {label: 'Female', value: 'Female'},
    ],

    lineupPages : ['Rosters', 'Scorecard', 'Statistics'],

    teamsPages: ['Team Overview', 'Player Stats', 'Team Schedule'],

    regex : {
        numberRegex: /^(\s*|\d+)$/
    },

    errorCodes : [400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 500, 501, 502, 503],
    messages: {
        errorMessage: "An error has occurred:",
    },

    forms: {
        club: 'https://forms.fillout.com/t/65WDfpxTC5us',
        player: 'https://cpl-admin-lv-ccc9hfbuabbjagbg.centralus-01.azurewebsites.net/player-registration',
        local: 'https://tally.so/embed/J9Xer4',
        codeOfConduct: 'https://tally.so/embed/0QxOMy',
    },

    externalLinks : {
        facebook: 'https://www.facebook.com/profile.php?id=61557405690235',
        instagram: 'https://www.instagram.com/crossclubnjpa/',
        ladderLeague: 'https://www.crossclubladder.com/clubs',
        genderLeague: 'https://www.crossclubpickleballleague.com/genderleagues',
        cplShop: 'https://crossclub.pckldrop.com/',
    }
}

export default constants;
